export const request = (
  path: RequestInfo,
  init?: RequestInit
): Promise<Response> => {
  return fetch(path, { ...{ mode: "cors" }, ...init });
};
